import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";
import remarkBreaks from "remark-breaks";


export const Text = (props: any) => {
  const { item } = props;
  return (
    <div className="flex flex-col grow">
      <ReactMarkdown
        remarkPlugins={[remarkBreaks, remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
      >
        {item.Description || ""}
      </ReactMarkdown>
    </div>
  );
};

export default Text;
